import {
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Chip,
  Tooltip,
} from "@mui/material";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";
import EditNoteIcon from "@mui/icons-material/EditNote";
import BadgeIcon from "@mui/icons-material/Badge";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import React, { useEffect, useState } from "react";
import UpdatedUploadFiles from "../../../services/UpdatedUploadFiles";
import EvaluacionesMedicasForm from "./EvaluacionesMedicasForm";
import EvaluacionesMedicasDelete from "./EvaluacionesMedicasDelete";
import { getData } from "../../../services/library";
import { enviarmails } from "../../../services/services";
import UploadFilesEval from "./UploadFilesEval";

const EvaluacionesMedicaItem = React.memo((props) => {
  const {
    id,
    id_candidato,
    prestador,
    fecha,
    aprobado_parte_rrhh,
    aprobado_parte_medico,
    uuid,
    user,
    nombre,
    apellido,
    username,
    usersurname,
    mostrarAlertaTemporal,
    getEvaluaciones,
    total_archivos,
  } = props;
  const [openModalAdj, setOpenModalAdj] = useState(false);
  const [openEvaluacionesDeleteModal, setOpenEvaluacionesDeleteModal] =
    useState(false);
  const [openEvaluacionesFormModal, setOpenEvaluacionesFormModal] =
    useState(false);

  const rrhh = localStorage.getItem("adminrrhh");
  const userLS = localStorage.getItem("user");

  const sector = Number(localStorage.getItem("sector")); // Convierte a número
  const puedeVerParteMedica = sector === 16 && total_archivos >= 1;
  console.log(puedeVerParteMedica);

  const [infoToDelete, setInfoToDelete] = useState({});
  return (
    <>
      {openModalAdj && ( // ADJUNTAR
        <UploadFilesEval
          fileId={uuid}
          open={openModalAdj}
          setOpen={setOpenModalAdj}
          readOnly={false}
          onClose={() => setOpenModalAdj(false)}
        />
        /*
         */
      )}
      {openEvaluacionesDeleteModal && (
        <EvaluacionesMedicasDelete
          id={infoToDelete.id}
          name={infoToDelete.name}
          id_candidato={id_candidato}
          estado={infoToDelete.estado}
          onClose={() => setOpenEvaluacionesDeleteModal(false)}
          obtenerEvaluaciones={getEvaluaciones}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
        />
      )}
      {openEvaluacionesFormModal && (
        <EvaluacionesMedicasForm
          idCandidato={id_candidato}
          isEditMode={true}
          props={props}
          onClose={() => setOpenEvaluacionesFormModal(false)}
          obtenerEvaluaciones={getEvaluaciones}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
        />
      )}
      <Card sx={{ maxWidth: 400, margin: 2, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h6" component="div" gutterBottom>
            Evaluación Médica
          </Typography>

          <Typography variant="body1" color="text.secondary">
            <strong>Nombre y apellido:</strong> {nombre} {apellido}
          </Typography>

          <Typography variant="body1" color="text.secondary">
            <strong>Prestador:</strong> {prestador}
          </Typography>

          <Typography variant="body1" color="text.secondary">
            <strong>Fecha:</strong> {new Date(fecha).toLocaleDateString()}
          </Typography>
          {(puedeVerParteMedica || rrhh === "1") && (
            <>
              <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                <Typography variant="body1" color="text.secondary">
                  <strong>Parte Médica:</strong>
                </Typography>
                <Chip
                  label={
                    aprobado_parte_medico === 1
                      ? "Aprobado"
                      : aprobado_parte_medico === 0
                      ? "Rechazado"
                      : "Pendiente"
                  }
                  color={
                    aprobado_parte_medico === 1
                      ? "success"
                      : aprobado_parte_medico === 0
                      ? "error"
                      : "default"
                  }
                  size="small"
                  sx={{ ml: 1 }}
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                <Typography variant="body1" color="text.secondary">
                  <strong>Parte RRHH:</strong>
                </Typography>
                <Chip
                  label={
                    aprobado_parte_rrhh === 1
                      ? "Aprobado"
                      : aprobado_parte_rrhh === 0
                      ? "Rechazado"
                      : "Pendiente"
                  }
                  color={
                    aprobado_parte_rrhh === 1
                      ? "success"
                      : aprobado_parte_rrhh === 0
                      ? "error"
                      : "default"
                  }
                  size="small"
                  sx={{ ml: 1 }}
                />
              </Box>
            </>
          )}

          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            <strong>Solicitud creada por:</strong> {username} {usersurname}
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "space-around", mt: 5 }}>
            {(puedeVerParteMedica || rrhh === "1") && (
              <>
                <Tooltip title={"Aprobar parte medico"}>
                  <IconButton
                    color={"success"}
                    onClick={() => {
                      setInfoToDelete({
                        id: id,
                        name: "medico",
                        estado: 1,
                      });
                      setOpenEvaluacionesDeleteModal(true);
                    }}
                  >
                    <MedicalInformationIcon fontSize="medium" />
                  </IconButton>
                </Tooltip>
                <Tooltip title={"Desaprobar parte medico"}>
                  <IconButton
                    color={"error"}
                    onClick={() => {
                      setInfoToDelete({
                        id: id,
                        name: "medico",
                        estado: 0,
                      });
                      setOpenEvaluacionesDeleteModal(true);
                    }}
                  >
                    <MedicalInformationIcon fontSize="medium" />
                  </IconButton>
                </Tooltip>
              </>
            )}
            {rrhh === "1" && (
              <Tooltip title={"Aprobar parte RRHH"}>
                <IconButton
                  color={"success"}
                  onClick={() => {
                    setInfoToDelete({
                      id: id,
                      name: "rrhh",
                      estado: 1,
                    });
                    setOpenEvaluacionesDeleteModal(true);
                  }}
                >
                  <BadgeIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
            )}
            {rrhh === "1" && (
              <Tooltip title={"Desaprobar parte RRHH"}>
                <IconButton
                  color={"error"}
                  onClick={() => {
                    setInfoToDelete({
                      id: id,
                      name: "rrhh",
                      estado: 0,
                    });
                    setOpenEvaluacionesDeleteModal(true);
                  }}
                >
                  <BadgeIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
            )}
            {(rrhh === "1" || user === userLS) && (
              <Tooltip title="Editar evaluación">
                <IconButton
                  color="primary"
                  onClick={() => setOpenEvaluacionesFormModal(true)}
                >
                  <EditNoteIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
            )}
            {(rrhh === "1" || puedeVerParteMedica) && (
              <Tooltip title="Adjuntos">
                <IconButton
                  color="orange"
                  onClick={() => setOpenModalAdj(true)}
                >
                  <PictureAsPdfIcon fontSize="medium" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </CardContent>
      </Card>
    </>
  );
});

export default EvaluacionesMedicaItem;
